module.exports = __webpack_public_path__ + "resources/img/ico_quote.7125f2caf7bfd2fafd50695f73d8e546.png";